<div class="component-container flex flex-col gap-[40px]">
  <div
    class="action-section mt-[40px]"
    >
    <div class="search-section flex flex-row gap-[10px]">
      <form
        [formGroup]="form"
        >
        <div class="search-section">
          <div class="search w-[400px]">
            <mat-icon (click)="search()" svgIcon="search"></mat-icon>
            <input
              class="search-input"
              formControlName="searchText"
              matInput
              placeholder="Search"
              >
            @if (form.controls.searchText.value) {
              <mat-icon
                (click)="close()"
                svgIcon="close"
              ></mat-icon>
            }
          </div>
        </div>
      </form>
      @if (selectedSortColumn) {
        <mat-form-field class="sort-dropdown">
          <mat-select (selectionChange)="onSortColumnChange($event)" [(value)]="selectedSortColumn"
            disableOptionCentering panelClass="activity-codes-sort-panel">
            <mat-select-trigger>
              {{ selectedSortColumn ? 'Sort by: ' + activityIdsListTableSortColumnNameMap[selectedSortColumn] : 'Sort: ' }}
            </mat-select-trigger>
            @for (column of displayedColumns; track column) {
              <mat-option [value]="column">
                {{ activityIdsListTableSortColumnNameMap[column]  | titlecase }}
              </mat-option>
            }
          </mat-select>
          <mat-icon (click)="removeSort($event)" class="sort-close">
            close
          </mat-icon>
        </mat-form-field>
      }
      @if (!selectedSortColumn) {
        <mat-form-field class="sort-dropdown nosort">
          <mat-select (selectionChange)="onSortColumnChange($event)" [(value)]="selectedSortColumn"
            disableOptionCentering panelClass="activity-codes-sort-panel">
            @for (column of sortByColumns; track column) {
              <mat-option [value]="column">
                {{ activityIdsListTableSortColumnNameMap[column] | titlecase }}
              </mat-option>
            }
          </mat-select>
          <div class="label text-type-8">Sort:</div>
          <mat-icon>sync_alt</mat-icon>
        </mat-form-field>
      }
    </div>

    <button
      (click)="onUploadClicked()"
      class="upload-btn"
      color="primary"
      mat-stroked-button
      >
      Upload
    </button>
  </div>
  @if (dataSource?.length) {
    <div class="bit-items-table">
      <table [dataSource]="dataSource" class="mat-elevation-z8 table" mat-table>
        <!-- ACTIVITY ID -->
        <ng-container matColumnDef="activityId">
          <th *matHeaderCellDef class="text-type-6" mat-header-cell>Activity Id
            @if (selectedSortColumn === 'activityId') {
              <span>
                <mat-icon (click)="toggleSortDirection()"
                class="sort-column">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
              </span>
            }
          </th>
          <td *matCellDef="let row" mat-cell>
            <div class="text-type-10">{{ row?.activity_id }}</div>
          </td>
        </ng-container>
        <!-- ACTIVITY NAME -->
        <ng-container matColumnDef="activityName">
          <th *matHeaderCellDef class="text-type-6" mat-header-cell> Activity Name
            @if (selectedSortColumn === 'activityName') {
              <span>
                <mat-icon (click)="toggleSortDirection()"
                class="sort-column">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
              </span>
            }
          </th>
          <td *matCellDef="let row" mat-cell>
            <div class="text-type-10 name">{{ row?.name }}</div>
          </td>
        </ng-container>
        <!-- LOCATION -->
        <ng-container matColumnDef="location">
          <th *matHeaderCellDef class="text-type-6" mat-header-cell> Location
            @if (selectedSortColumn === 'location') {
              <span>
                <mat-icon (click)="toggleSortDirection()"
                class="sort-column">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
              </span>
            }
          </th>
          <td *matCellDef="let row" mat-cell>
            <div class="text-type-10 location">{{ row?.location }}</div>
          </td>
        </ng-container>
        <!-- SEGMENT -->
        <ng-container matColumnDef="segment">
          <th *matHeaderCellDef class="text-type-6" mat-header-cell> Segment
            @if (selectedSortColumn === 'segment') {
              <span>
                <mat-icon (click)="toggleSortDirection()"
                class="sort-column">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
              </span>
            }
          </th>
          <td *matCellDef="let row" mat-cell>
            <div class="text-type-10">{{ row?.segment }}</div>
          </td>
        </ng-container>
        <!-- Header and Row Definitions -->
        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr (click)="rowClicked(row)"
          *matRowDef="let row; columns: displayedColumns;"
          [class.highlighted-row]="row === selectedRow"
        mat-row></tr>
      </table>
    </div>
  }
  @if (!dataSource?.length) {
    <div class="no-data text-type-8 mt-[80px]">
      You dont have any activity ids yet. Use this <span (click)="getTemplate()" class="clickable">template</span> to
      import your data.
    </div>
    <app-primary-button
      (handleClick)="import('fileUploadRef')"
      class="import-btn w-[200px]"
      >
      Import
    </app-primary-button>
    <input
      #fileUploadRef
      (change)="handleFileUpload()"
      [id]="'fileUploadRef'"
      class="input-files"
      type="file"
      />
  }
  <app-paginator
    (pageChanged)="onPageChanged($event)"
    [itemsPerPage]="pagination?.pageSize"
    [maxVisiblePages]="5"
    [totalItems]="totalRecords"
    class="paginator"
    />
</div>


